export type ColorRGB = string;

export type DrawFn = (
	ctx: CanvasRenderingContext2D,
	width: number,
	height: number,
	t: number,
) => void;

export interface CanvasAnimOptions {
	reducedMotion?: boolean;
}

export interface CanvasMountHandle {
	destroy(): void;
}

const FALLBACK_ACC: ColorRGB = "150,112,250";
const FALLBACK_ACC2: ColorRGB = "56,189,248";
const FALLBACK_GREEN: ColorRGB = "52,211,153";

function readCssVar(name: string, fallback: ColorRGB): ColorRGB {
	if (typeof document === "undefined") return fallback;
	const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
	return v || fallback;
}

export function getAccentRgb(): ColorRGB {
	return readCssVar("--acc-rgb", FALLBACK_ACC);
}

export function getAccent2Rgb(): ColorRGB {
	return readCssVar("--acc2-rgb", FALLBACK_ACC2);
}

export function getGreenRgb(): ColorRGB {
	return readCssVar("--green-rgb", FALLBACK_GREEN);
}

export function getPrimaryRgb(): ColorRGB {
	return readCssVar("--acc-rgb", FALLBACK_ACC);
}

export function prefersReducedMotion(): boolean {
	if (typeof window === "undefined") return false;
	return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

export function rgba(rgb: ColorRGB, alpha: number): string {
	return `rgba(${rgb},${alpha.toFixed(3)})`;
}
